import { eventingApi } from '../../../../../services/eventingApi';
import { useApiResource } from '../hooks/useApiResource';
import { formatDateTime } from '../shared/format';
import ResourceState from '../shared/ResourceState';
import { Badge } from '../shared/ui';

const DeliveryReceipts = ({ eventId }: { eventId: string }) => {
  const deliveries = useApiResource(() => eventingApi.listDeliveries(eventId), [eventId]);

  return (
    <>
      <ResourceState resource={deliveries} emptyText="Nenhum consumidor registrou esta entrega (ou o recibo já passou dos 30 dias)." />
      <ul className="space-y-2">
        {(deliveries.data ?? []).map((receipt) => (
          <li
            key={`${receipt.consumer}-${receipt.processedAt}`}
            className="flex items-center justify-between rounded-md border border-gray-200 px-3 py-2 text-xs dark:border-gray-700 dark:text-gray-100"
          >
            <span className="font-mono">{receipt.consumer}</span>
            <span>{receipt.deliveryFormatted}</span>
            <Badge label={{ text: receipt.outcomeFormatted, color: receipt.outcome === 'PROCESSED' ? 'green' : 'slate' }} />
            <span>{formatDateTime(receipt.processedAt)}</span>
          </li>
        ))}
      </ul>
    </>
  );
};

export default DeliveryReceipts;
